import { render } from "./OrganManage.vue?vue&type=template&id=792e6abe&scoped=true"
import script from "./OrganManage.vue?vue&type=script&lang=js"
export * from "./OrganManage.vue?vue&type=script&lang=js"

import "./OrganManage.vue?vue&type=style&index=0&id=792e6abe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792e6abe"]])

export default __exports__